var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { clone, cloneDeep, forEach, isNil, isNumber, isString } from 'lodash';
import { Stratus } from '@stratusjs/runtime/stratus';
import { element } from 'angular';
import 'angular-material';
import 'angular-sanitize';
import { Collection } from '@stratusjs/angularjs/services/collection';
import { isJSON, safeUniqueId } from '@stratusjs/core/misc';
import { cookie } from '@stratusjs/core/environment';
const min = !cookie('env') ? '.min' : '';
const packageName = 'idx';
const moduleName = 'office';
const componentName = 'list';
const localDir = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/src/${moduleName}/`;
Stratus.Components.IdxOfficeList = {
    bindings: {
        elementId: '@',
        tokenUrl: '@',
        urlLoad: '@',
        searchOnLoad: '@',
        detailsLinkPopup: '@',
        detailsLinkUrl: '@',
        detailsLinkTarget: '@',
        orderOptions: '@',
        query: '@',
        queryService: '@',
        template: '@',
        variableSync: '@'
    },
    controller($anchorScroll, $attrs, $q, $mdDialog, $timeout, $scope, $window, Idx) {
        $scope.uid = safeUniqueId(packageName, moduleName, componentName);
        $scope.elementId = $attrs.elementId || $scope.uid;
        Stratus.Instances[$scope.elementId] = $scope;
        if ($attrs.tokenUrl) {
            Idx.setTokenURL($attrs.tokenUrl);
        }
        let defaultOptions;
        let defaultQuery;
        let lastQuery;
        const init = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            var _c, _d;
            $scope.urlLoad = $attrs.urlLoad && isJSON($attrs.urlLoad) ? JSON.parse($attrs.urlLoad) : false;
            $scope.searchOnLoad = $attrs.searchOnLoad && isJSON($attrs.searchOnLoad) ? JSON.parse($attrs.searchOnLoad) : false;
            $scope.detailsLinkPopup = $attrs.detailsLinkPopup && isJSON($attrs.detailsLinkPopup) ?
                JSON.parse($attrs.detailsLinkPopup) : true;
            $scope.detailsLinkUrl = $attrs.detailsLinkUrl || '/property/office/details';
            $scope.detailsLinkTarget = $attrs.detailsLinkTarget || '_self';
            $scope.query = $attrs.query && isJSON($attrs.query) ? JSON.parse($attrs.query) : {};
            $scope.query.service = $attrs.queryService && isJSON($attrs.queryService) ?
                JSON.parse($attrs.queryService) : $scope.query.service || [];
            $scope.query.order =
                $scope.query.order && isString($scope.query.order) && isJSON($scope.query.order) ? JSON.parse($scope.query.order) :
                    $attrs.queryOrder && isJSON($attrs.queryOrder) ? JSON.parse($attrs.queryOrder) : $scope.query.order || null;
            (_a = (_c = $scope.query).page) !== null && _a !== void 0 ? _a : (_c.page = null);
            (_b = (_d = $scope.query).perPage) !== null && _b !== void 0 ? _b : (_d.perPage = ($attrs.queryPerPage && isString($attrs.queryPerPage) ? parseInt($attrs.queryPerPage, 10) : null) ||
                ($attrs.queryPerPage && isNumber($attrs.queryPerPage) ? $attrs.queryPerPage : null) ||
                25);
            $scope.query.where = $attrs.queryWhere && isJSON($attrs.queryWhere) ? JSON.parse($attrs.queryWhere) : $scope.query.where || [];
            defaultOptions = JSON.parse(JSON.stringify($scope.query.where));
            defaultQuery = JSON.parse(JSON.stringify($scope.query.where));
            Idx.registerListInstance($scope.elementId, moduleName, $scope);
            if ($scope.searchOnLoad) {
                yield $scope.search($scope.query, false, false);
            }
            $scope.$applyAsync(() => {
                $scope.initialized = true;
                Idx.emit('init', $scope);
            });
        });
        this.$onInit = () => {
            $scope.Idx = Idx;
            $scope.collection = new Collection({});
            let initNow = true;
            if (Object.prototype.hasOwnProperty.call($attrs.$attr, 'initNow')) {
                initNow = isJSON($attrs.initNow) ? JSON.parse($attrs.initNow) : false;
            }
            if (initNow) {
                init().then();
                return;
            }
            const stopWatchingInitNow = $scope.$watch('$ctrl.initNow', (initNowCtrl) => {
                if (initNowCtrl !== true) {
                    return;
                }
                if (!$scope.initialized) {
                    init().then();
                }
                stopWatchingInitNow();
            });
        };
        $scope.$watch('collection.models', () => {
            if ($scope.collection.completed) {
                Idx.emit('collectionUpdated', $scope, clone($scope.collection));
            }
        });
        $scope.getPageModels = () => {
            const offices = [];
            const models = $scope.collection.models;
            models.slice(($scope.query.perPage * ($scope.query.page - 1)), ($scope.query.perPage * $scope.query.page)).forEach((member) => {
                offices.push(member);
            });
            return offices;
        };
        $scope.scrollToModel = (model) => {
            $anchorScroll(`${$scope.elementId}_${model._id}`);
        };
        $scope.search = (query, refresh, updateUrl) => __awaiter(this, void 0, void 0, function* () {
            return $q((resolve) => __awaiter(this, void 0, void 0, function* () {
                query !== null && query !== void 0 ? query : (query = {});
                updateUrl = updateUrl === false ? updateUrl : true;
                if (Object.keys(query.where).length > 0) {
                    $scope.query.where = query.where;
                }
                if (query.where.page) {
                    query.page = query.where.page;
                    delete query.where.page;
                }
                if (query.where.Page) {
                    query.page = query.where.Page;
                    delete query.where.Page;
                }
                if (query.page) {
                    $scope.query.page = query.page;
                }
                if (refresh) {
                    $scope.query.page = 1;
                }
                if (query.where.order) {
                    query.order = query.where.order;
                    delete query.where.order;
                }
                if (query.where.Order) {
                    query.order = query.where.Order;
                    delete query.where.Order;
                }
                if (query.order) {
                    $scope.query.order = query.order;
                }
                if (query.hasOwnProperty('service') &&
                    !isNil(query.service)) {
                    $scope.query.service = query.service;
                }
                Idx.emit('searching', $scope, clone($scope.query));
                try {
                    const results = yield Idx.fetchOffices($scope.elementId, 'collection', $scope.query, refresh);
                    lastQuery = cloneDeep($scope.query);
                    Idx.emit('searched', $scope, clone($scope.query));
                    resolve(results);
                }
                catch (e) {
                    console.error('Unable to fetchMembers:', e);
                }
            }));
        });
        $scope.pageChange = (pageNumber, ev) => __awaiter(this, void 0, void 0, function* () {
            if ($scope.collection.pending) {
                return;
            }
            Idx.emit('pageChanging', $scope, clone($scope.query.page));
            if (ev) {
                ev.preventDefault();
            }
            $scope.query.page = pageNumber;
            yield $scope.search();
            Idx.emit('pageChanged', $scope, clone($scope.query.page));
        });
        $scope.pageNext = (ev) => __awaiter(this, void 0, void 0, function* () {
            if ($scope.collection.pending) {
                return;
            }
            if (!$scope.query.page) {
                $scope.query.page = 1;
            }
            if ($scope.collection.completed && $scope.query.page < $scope.collection.meta.data.totalPages) {
                if (isString($scope.query.page)) {
                    $scope.query.page = parseInt($scope.query.page, 10);
                }
                yield $scope.pageChange($scope.query.page + 1, ev);
            }
        });
        $scope.pagePrevious = (ev) => __awaiter(this, void 0, void 0, function* () {
            if ($scope.collection.pending) {
                return;
            }
            if (!$scope.query.page) {
                $scope.query.page = 1;
            }
            if ($scope.collection.completed && $scope.query.page > 1) {
                if (isString($scope.query.page)) {
                    $scope.query.page = parseInt($scope.query.page, 10);
                }
                const prev = $scope.query.page - 1 || 1;
                yield $scope.pageChange(prev, ev);
            }
        });
        $scope.orderChange = (order, ev) => __awaiter(this, void 0, void 0, function* () {
            if ($scope.collection.pending) {
                return;
            }
            Idx.emit('orderChanging', $scope, clone(order));
            if (ev) {
                ev.preventDefault();
            }
            $scope.query.order = order;
            yield $scope.search(null, true, true);
            Idx.emit('orderChanged', $scope, clone(order));
        });
        $scope.highlightModel = (model, timeout) => {
            var _a;
            timeout !== null && timeout !== void 0 ? timeout : (timeout = 0);
            (_a = model._unmapped) !== null && _a !== void 0 ? _a : (model._unmapped = {});
            $scope.$applyAsync(() => {
                model._unmapped._highlight = true;
            });
            if (timeout > 0) {
                $timeout(() => {
                    $scope.unhighlightModel(model);
                }, timeout);
            }
        };
        $scope.unhighlightModel = (model) => {
            var _a;
            if (model) {
                (_a = model._unmapped) !== null && _a !== void 0 ? _a : (model._unmapped = {});
                $scope.$applyAsync(() => {
                    model._unmapped._highlight = false;
                });
            }
        };
        $scope.displayModelDetails = (model, ev) => {
            if (ev) {
                ev.preventDefault();
            }
            if ($scope.detailsLinkPopup === true) {
                const templateOptions = {
                    element_id: 'property_member_detail_popup',
                    service: model._ServiceId,
                    'member-key': model.MemberKey,
                    'page-title': true
                };
                if ($scope.googleApiKey) {
                    templateOptions['google-api-key'] = $scope.googleApiKey;
                }
                let template = '<md-dialog aria-label="' + model.MemberKey + '">' +
                    '<stratus-idx-member-details ';
                forEach(templateOptions, (optionValue, optionKey) => {
                    template += `${optionKey}='${optionValue}'`;
                });
                template +=
                    '></stratus-idx-member-details>' +
                        '</md-dialog>';
                $mdDialog.show({
                    template,
                    parent: element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true
                })
                    .then(() => {
                }, () => {
                    Idx.setPageTitle();
                    $timeout(() => Idx.unregisterDetailsInstance('property_member_detail_popup', 'member'), 10);
                });
            }
            else {
                $window.open($scope.getDetailsURL(model), $scope.detailsLinkTarget);
            }
        };
        $scope.variableInject =
            (member) => __awaiter(this, void 0, void 0, function* () {
                $scope.variableSyncing = $attrs.variableSync && isJSON($attrs.variableSync) ? JSON.parse($attrs.variableSync) : {};
                Object.keys($scope.variableSyncing).forEach(elementId => {
                    const varElement = Idx.getInput(elementId);
                    if (varElement) {
                        if (Object.prototype.hasOwnProperty.call(member, $scope.variableSyncing[elementId])) {
                            varElement.val(member[$scope.variableSyncing[elementId]]);
                        }
                        else if ($scope.variableSyncing[elementId] === 'MemberFullName' &&
                            Object.prototype.hasOwnProperty.call(member, 'MemberFirstName') &&
                            Object.prototype.hasOwnProperty.call(member, 'MemberLastName')) {
                            varElement.val(member.MemberFirstName + ' ' + member.MemberLastName);
                        }
                        else if ($scope.variableSyncing[elementId] === 'MemberFirstName' &&
                            !Object.prototype.hasOwnProperty.call(member, 'MemberFirstName') &&
                            Object.prototype.hasOwnProperty.call(member, 'MemberFullName')) {
                            const nameArray = member.MemberFullName.split(' ');
                            const firstName = nameArray.shift();
                            varElement.val(firstName);
                        }
                        else if ($scope.variableSyncing[elementId] === 'MemberLastName' &&
                            !Object.prototype.hasOwnProperty.call(member, 'MemberLastName') &&
                            Object.prototype.hasOwnProperty.call(member, 'MemberFullName')) {
                            const nameArray = member.MemberFullName.split(' ');
                            const lastName = nameArray.join(' ');
                            varElement.val(lastName);
                        }
                        else if ($scope.variableSyncing[elementId] === 'OfficeNumber') {
                            if (Object.prototype.hasOwnProperty.call(member, 'OfficeMlsId')) {
                                varElement.val(member.OfficeMlsId);
                            }
                            else if (Object.prototype.hasOwnProperty.call(member, 'OfficeKey')) {
                                varElement.val(member.OfficeKey);
                            }
                        }
                    }
                });
            });
        $scope.on = (emitterName, callback) => Idx.on($scope.elementId, emitterName, callback);
        $scope.remove = () => {
        };
    },
    templateUrl: ($attrs) => `${localDir}${$attrs.template || componentName}.component${min}.html`
};

//# sourceMappingURL=list.component.js.map
